import { TFunction } from '@mint-lib/i18n';

export const getDescriptionOfIntegration = (
  integration: string,
  t: TFunction,
) => {
  const descriptions = DescriptionsOfIntegrations(t)[integration];

  return descriptions || [];
};

export const getIntegrationTypeDescription = (type: string, t: TFunction) => {
  return IntegrationTypeDescription(t)[type];
};

const DescriptionsOfIntegrations = (
  t: TFunction,
): { [integration: string]: string[] } => ({
  ias: [
    t(
      'IAS delivers innovative, industry-leading digital advertising solutions that are designed to keep you ahead of the competition. Achieve highly viewable, fraud-free, safe and suitable impressions across screens. More importantly, receive optimization insights for your campaigns that will save you time and money.',
    ),
  ],
  appsflyer: [
    t(
      'AppsFlyer is a mobile apps analytics & marketing software that enables developers, businesses, and marketing agencies to track and optimize their acquisition funnel.',
    ),
    t(
      'The platform integrates with numerous apps, so advertisers can perform comprehensive promotional campaigns. This solution is developed for data-driven marketing professionals to make responsible decisions in order to maximize their ROI and grow their mobile business. It provides deep analytics, performance metrics, and flexible reporting. AppsFlyer associates each install to a proper campaign or media source.',
    ),
    t(
      'One of the most prominent features is retargeting attribution; pointing out which campaign is best in re-engaging with users. The platform quantifies the value of this re-engagement with in-app events to gauge and enhance retargeting ROI. Moreover, with effective external integrations, it is possible to attribute broadcast TV campaigns.',
    ),
  ],
});

const IntegrationTypeDescription = (
  t: TFunction,
): {
  [type: string]: string;
} => ({
  virtual: t(
    'A virtual integration do not yet come with an API connection. The MINT Platform deduces the campaign delivery data by matching the Adserver and analytics data with the planning data at the media row level. It means that you may follow the campaigns results in the Insights dashboards, as well as enjoy AI-based budget recommendations.',
  ),
  one_way: t(
    'A 1-way integration is an API connection that allows a mono-directional communication with the partner in read mode. It means that you may import campaign data, sync them and enjoy fresh data of the Insights dashboards and AI-based recommendations.',
  ),
  two_way: t(
    'A 2-way integration is an API connection that allows a bi-directional communication with the partner both in read and write mode. It means that changes applied into the MINT Platform are automatically written into the partner account. At the same time, you may import campaign data, sync them and enjoy fresh data of the Insights dashboards and AI-based recommendations.',
  ),
});
